import AmexExpandableSections from './AmexExpandableSections';

export default AmexExpandableSections;
